@if (metricsData.length) {
    <mat-card class="cardWithShadow">
    <mat-card-content class="p-24">
        <!-- Summary KPIs -->
        <div class="d-flex justify-content-between flex-wrap gap-16">
            @for (key of ['totalCalled', 'totalCompleted', 'totalFailed', 'avgTaskTime']; track key) {
                <mat-card class="kpi-card">
                    <mat-card-header>
                        <mat-card-title>
                            {{
                                key === 'totalCalled' ? summary.totalCalled :
                                    key === 'totalCompleted' ? summary.totalCompleted :
                                        key === 'totalFailed' ? summary.totalFailed :
                                            key === 'avgTaskTime' ? summary.avgTaskTime + ' s' : ''
                            }}
                        </mat-card-title>
                    </mat-card-header>
                    <mat-card-content>
                        {{
                            key === 'totalCalled' ? 'Tasks Called' :
                                key === 'totalCompleted' ? 'Completed' :
                                    key === 'totalFailed' ? 'Failed' :
                                        key === 'avgTaskTime' ? 'Avg Task Time' : ''
                        }}
                    </mat-card-content>
                </mat-card>
            }
        </div>
        <div class="d-flex flex-wrap gap-24" style="margin-top: 24px;">
            <!-- Timeline Chart -->
            <mat-card class="chart-card" style="flex: 1 1 300px;">
                <mat-card-header>
                    <mat-card-title>Avg Task Time Over Time</mat-card-title>
                </mat-card-header>
                <mat-card-content>
                    <apx-chart
                            [series]="timelineSeries"
                            [chart]="timelineChart"
                            [xaxis]="timelineXAxis"
                            [stroke]="timelineStroke"
                            [tooltip]="timelineTooltip">
                    </apx-chart>
                </mat-card-content>
            </mat-card>
            <!-- Issues Donut Chart -->
            <mat-card class="chart-card" style="flex: 1 1 300px;">
                <mat-card-header>
                    <mat-card-title>Task Issues</mat-card-title>
                </mat-card-header>
                <mat-card-content>
                    <apx-chart
                            [series]="issuesSeries"
                            [chart]="issuesChart"
                            [labels]="issuesLabels"
                            [tooltip]="issuesTooltip">
                    </apx-chart>
                </mat-card-content>
            </mat-card>
        </div>
        <!-- Usage Stacked Bar Chart -->
        <mat-card class="chart-card" style="margin-top: 24px;">
            <mat-card-header>
                <mat-card-title>Daily Task Usage</mat-card-title>
            </mat-card-header>
            <mat-card-content>
                <apx-chart
                        [series]="usageSeries"
                        [chart]="usageChart"
                        [plotOptions]="usagePlotOptions"
                        [dataLabels]="usageDataLabels"
                        [legend]="usageLegend"
                        [xaxis]="usageXAxis"
                        [responsive]="usageResponsive">
                </apx-chart>
            </mat-card-content>
        </mat-card>
    </mat-card-content>
    </mat-card>
}
